import React from 'react'
import Calendar from "react-range-calendar";


import { useState } from 'react';
import dateUtils from './utilities/DateUtilities';
import { useEffect } from 'react';


const DateFilterCalendar = (props) => {
    const [dateRange, setDateRange] = useState([new Date(), new Date()])

    const handleDateClick = (minDate, maxDate) => {

        var resultedDate;

        if (props.customRangesOperator != null) {
            if (props.customRangesOperator?.columnType === "DATE") {
                resultedDate = dateUtils.getCalendarFormattedDateByTimeStamp(minDate)
            } else if (props.customRangesOperator?.columnType === "DATETIME") {
                resultedDate = dateUtils.getFormattedDateTimeForDateTimeColumns(minDate)
            }
        }
        setDateRange({ dateRange: [minDate] });
        props.setSelectedDateOptionIs("");
        props.setDateRangesData(minDate);
        props.handleSelectedDateRange(resultedDate)

    }

    useEffect(() => {
        if (props.customRangesOperator != null) {
            if (props.filterType === "free-range") {
                setDateRange([new Date(), new Date()])
            } else {
                setDateRange([new Date(props.customRangesOperator?.value), new Date(props.customRangesOperator?.value)])
            }
        }
    }, [props.filterType, props.customRangesOperator]);


    return (
        // <Calendar
        //     visible={true}
        //     dateRange={dateRange}
        //     // onDateClick={date => {
        //     //     setDateRange({ dateRange: [date] });
        //     //     props.setSelectedDateOptionIs("");
        //     //     props.setDateRangesData(date);
        //     // }}
        //     onDateClick={date => handleDateClick(date)}
        //     // type="single"
        //     type={props.filterType}
        // />

        <Calendar
            visible={true}
            dateRange={dateRange}
            // onDateClick={date => {
            //     setDateRange({ dateRange: [date] });
            //     props.setSelectedDateOptionIs("");
            //     props.setDateRangesData(date);
            // }}
            onDateClick={(minDate, maxDate) => handleDateClick(minDate, maxDate)}
            // type="single"
            type={props.filterType}
        />
    )
}

export default DateFilterCalendar